import { useState } from "react";

import { PageStep } from "@/components/_module/home/creditCard/index";
import PageLoader from "@/components/ui/PageLoader";
import { Button } from "@/components/ui/button/button";
import { useAuth } from "@/context/auth-context";
import useGetCreditCards from "@/features/credit-cards/useGetCreditCards";
import { useNavigate, useLoaderData } from "@tanstack/react-router";
import clsx from "clsx";
import { PlusIcon } from "lucide-react";
import AddCreditCard from "../../../components/_module/home/creditCard";
import CardView from "./view/_components/CardCarousel";

const CardViewPage = () => {
	const navigate = useNavigate();
	const [pageStep, setPageStep] = useState<PageStep>("card");
	const { user } = useAuth();
	const { location_id } = useLoaderData({ from: "__root__" });
	const creditCardsQuery = useGetCreditCards({
		guestId: user.id,
		locationId: location_id,
	});

	return (
		<div className="h-full">
			<PageLoader isFullscreenLoading={true} query={creditCardsQuery}>
				{(creditCards) => {
					const hasCreditCard = creditCards.length > 0;
					const sortedByDefaultCardFirst = creditCards.slice().sort((a, b) => {
						if (a.default && !b.default) return -1;
						if (!a.default && b.default) return 1;
						return 0;
					});

					return (
						<>
							<div className="flex items-end justify-between px-6">
								<p className="mt-3 text-2xl font-bold text-textDark">
									My Cards
								</p>
								{hasCreditCard && (
									<Button
										size={"sm"}
										variant={"outline"}
										onClick={() =>
											navigate({
												to: "/main/card/new",
											})
										}
										className="space-x-1"
									>
										<PlusIcon /> Add Card
									</Button>
								)}
							</div>
							<div
								className={clsx(
									"h-full mt-7",
									pageStep === "add" ? "px-6" : "px-0",
								)}
							>
								{hasCreditCard ? (
									<CardView creditCards={sortedByDefaultCardFirst} />
								) : (
									<AddCreditCard setPageStep={setPageStep} type="card" />
								)}
							</div>
						</>
					);
				}}
			</PageLoader>
		</div>
	);
};

export default CardViewPage;
